import { call, put, takeEvery, all, fork, select, takeLatest } from 'redux-saga/effects'
import { fetchWorklistAPI, updateStudyAPI } from '../../../services/group-admin-service';
import { FETCH_WORKLIST, FETCH_WORKLIST_ERROR, FETCH_WORKLIST_SUCCESS, FETCH_WORKLIST_START, SET_WORKLIST_PAGINATION, SET_WORKLIST_FILTER, UPDATE_STUDY, UPDATE_STUDY_START, UPDATE_STUDY_SUCCESS } from '../../actions/groupadmin/worklistActions';
import { message } from 'antd';

function* fetchGroupAdminWorklist({ payload }) {
    try {
        yield put({ type: FETCH_WORKLIST_START })
        let response = yield call(fetchWorklistAPI, payload);
        if (response.data) {
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            }
            yield put({ type: FETCH_WORKLIST_SUCCESS, worklist: response.data.groupAdminWorklist })
            yield put({ type: SET_WORKLIST_PAGINATION, pagination });
            yield put({ type: SET_WORKLIST_FILTER, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_WORKLIST_ERROR });
            message.error('Failed to fetch worklist!');
        }

    } catch (error) {
        message.error('Failed to fetch worklist!');
        yield put({ type: FETCH_WORKLIST_ERROR, error })
    }

}


function* updateStudy({ payload }) {
    try {
        yield put({ type: UPDATE_STUDY_START })

        let response = yield call(updateStudyAPI, payload);

        if (response.data) {
            message.success('Updated visit successfully');
            yield put({ type: UPDATE_STUDY_SUCCESS, visit: payload })
        } else {
            yield put({ type: FETCH_WORKLIST_ERROR });
            message.error('Failed to update visit!');
        }
    } catch (error) {
        message.error('Failed to update visit!');
        yield put({ type: FETCH_WORKLIST_ERROR, error })
    }
}

function* fetchGroupAdminWorklistWatcher() {
    yield takeLatest(FETCH_WORKLIST, fetchGroupAdminWorklist)
    yield takeLatest(UPDATE_STUDY, updateStudy)
}

export default function* rootSaga() {
    yield all([
        fetchGroupAdminWorklistWatcher()
    ]);
}